<template>
  <div class="project-container">

    <div class="greo-container">
        <ProjectGreoComponent/>
    </div>

    <div class="tldr-container">
        <ProjectTLDRComponent/>
    </div>

    <div class="stashe-container">
        <ProjectStasheComponent/>
    </div>

  </div>
</template>

<script>
import ProjectGreoComponent from './Greo/ProjectGreo.vue';
import ProjectTLDRComponent from './TLDR/ProjectTLDR.vue';
import ProjectStasheComponent from './Stashe/ProjectStashe.vue';

export default {
  name: 'ProjectsContainer',
  components: {
      ProjectGreoComponent,
      ProjectTLDRComponent,
      ProjectStasheComponent,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.project-container {
    max-width: 93.5rem;
    padding: 4em;
}


.greo-container, .tldr-container, .stashe-container {
    padding: 4em 0;
    min-height: 80vh;
}

</style>



// WEBPACK FOOTER //
// src/components/Apps/ProjectsContainer.vue